import { render } from "./Reflection.vue?vue&type=template&id=2324803e&scoped=true&lang=pug"
import script from "./Reflection.vue?vue&type=script&lang=js"
export * from "./Reflection.vue?vue&type=script&lang=js"

import "./Reflection.vue?vue&type=style&index=0&id=2324803e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2324803e"]])

export default __exports__